import {TOGGLE_MODAL} from './index';

export function toggleModal(key, modalState) {
  return {
    type: TOGGLE_MODAL,
    key: key,
    value: modalState,
  };
}
